import "./AppHeader.css";
import { useTranslation } from "../../i18n/i18n";

const AppHeader = () => {
	const { translate } = useTranslation();

	return (
		<div className="app-header">
			<img className="app-icon" src="/app-logo.png" alt="App Logo" />
			<h1 className="application-title">{translate("app.title")}</h1>
			<h2 className="application-description">
				{translate("app.description")}
			</h2>
		</div>
	);
};

export default AppHeader;
